import { z } from "zod";

const pointSchema = z.object({
  x: z.number().int().nonnegative(),
  y: z.number().int().nonnegative(),
});

const beadSchema = z.object({
  id: z.string().min(1),
  color: z.string().min(1),
});

const cellSchema = pointSchema.extend({
  layers: z.array(beadSchema).min(1),
});

const chunkSchema = z.object({
  id: z.string().min(1),
  origin: pointSchema,
  cells: z.array(cellSchema).min(1),
});

const ruleSchema = z.object({
  trayCapacity: z.number().int().positive().optional(),
  maxTrayCapacity: z.number().int().positive().optional(),
  matchSize: z.number().int().positive().optional(),
  failOnTimeout: z.boolean().optional(),
});

export const levelDefinitionSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  durationMs: z.number().positive(),
  board: z.object({
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    chunks: z.array(chunkSchema).min(1),
  }),
  targetSlots: z.array(pointSchema.extend({
    id: z.string().min(1),
    color: z.string().min(1),
  })).min(1),
  rules: ruleSchema.optional(),
});
